import React, { Component } from "react";
import { List, Image } from "semantic-ui-react";
import supplyChainLogo from "../../assets/supplychain-logo.png";
import SimulationTitle from "./SimulationTitle";
import HelpHoverComponent from "../helpers/HelpHoverComponent";
import moment from "moment";
import { getLanguagePrefix } from "../utilities/LanguageUtilities";
import { withTranslation } from "react-i18next";

class SupplyChainDetailComponent extends Component {
  formatDate = (date, language) => {
    return moment(date)
      .locale(getLanguagePrefix(language))
      .format(`MMMM D, YYYY [${this.props.t("at")}] hh:mm A`);
  };

  render() {
    const translate = this.props.t;
    const simulationDetails = this.props.simulationDetails;
    const loadingDetails = this.props.loadingDetails;
    const language = this.props.language;

    let detailBoxStyles = "detailsDataLoading";
    let listDetails = [];
    if (!loadingDetails && simulationDetails) {
      detailBoxStyles = "detailsDataCharged";

      let startDateText = null;
      let endDateText = null;
      if (simulationDetails.professorManagedProgress) {
        startDateText = translate("MedicaDetailScreen:professorManaged");
        endDateText = translate("MedicaDetailScreen:professorManaged");
      } else {
        startDateText = this.formatDate(simulationDetails.startTime, language);
        endDateText = this.formatDate(simulationDetails.endTime, language);
      }

      listDetails = [
        {
          item: translate("Common:status"),
          content: translate(`Common:${simulationDetails.status}`),
        },
        {
          item: translate("Common:currentDay"),
          content: simulationDetails.currentSimulationDay,
        },
        {
          item: translate("Common:GameMode"),
          content: translate(`SupplyChainCommon:${simulationDetails.gameMode}`),
        },
        { key: 3, item: translate("Common:startDate"), content: startDateText },
        { key: 4, item: translate("Common:endDate"), content: endDateText },
      ];
    } else {
      listDetails = [
        { item: translate("Common:status"), content: "" },
        {
          item: translate("SupplyChainCommon:GameMode"),
          content: "",
        },
      ];
    }
    return (
      <div>
        <SimulationTitle title={simulationDetails && !loadingDetails ? simulationDetails.name : ""} />
        <div className="detailsContainer">
          <div className="supplyChainSimulationIcon">
            <Image className="supplyChainDetailLogo" src={supplyChainLogo} size="small" />
          </div>
          <div className={`detailsData ${detailBoxStyles}`}>
            <p>{translate("SupplyChainDetailScreen:simulationDetails").toUpperCase()}</p>
            <List>
              {listDetails.map((detail, index) => {
                if (!detail.content) return null;
                let helpHoverComponent = null;
                if (detail.hasHelp) {
                  helpHoverComponent = <HelpHoverComponent helpMessage={translate(detail.helpMessage)} />;
                }
                return (
                  <List.Item key={index}>
                    {loadingDetails === true ? (
                      <div className="animated-background" />
                    ) : (
                      <div>
                        <strong>{detail.item}: </strong>
                        {detail.content}
                        {helpHoverComponent}
                      </div>
                    )}
                  </List.Item>
                );
              })}
            </List>
          </div>
        </div>
      </div>
    );
  }
}

export default withTranslation("Common", "SupplyChainCommon")(SupplyChainDetailComponent);
